import { apiCall, createQueryString } from "../imports"

const PREFIX = "shop/products"

export default {
    importPricesExcel(data) {
        return apiCall('post', `${PREFIX}/prices/excel`, data)
    },

    getProductsPaginated(filters) {
        return apiCall('get', `${PREFIX}/paginated${createQueryString(filters)}`)
    },

    normalizeDatabase() {
        return apiCall('get', 'shop/normlize')
    },

    getProducts(filters) {
        return apiCall('get', `${PREFIX}${createQueryString(filters)}`)
    },

    getProduct(productID) {
        return apiCall('get', `${PREFIX}/${productID}`)
    },

    getProductRelations(productID) {
        return apiCall('get', `${PREFIX}/${productID}/relations`)
    },

    postProductRelation(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/relations`, data)
    },

    deleteProductRelation(productID, relationID) {
        return apiCall('delete', `${PREFIX}/${productID}/relations/${relationID}`)
    },

    getProductInfo(productId) {
        return apiCall('get', `${PREFIX}/${productId}/info`)
    },

    createProduct(data) {
        return apiCall('post', `${PREFIX}`, data)
    },

    updateProductInfo(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/info`, data)
    },

    toggleStatus(productID) {
        return apiCall('patch', `${PREFIX}/${productID}/status`)
    },

    deleteProduct(productID) {
        return apiCall('delete', `${PREFIX}/${productID}`)
    },

    updateProductDetail(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/details`, data)
    },

    getProductDetail(productID) {
        return apiCall('get', `${PREFIX}/${productID}/details`)
    },

    getProductImages(productID) {
        return apiCall('get', `${PREFIX}/${productID}/images`)
    },

    deleteProductImage(imageID) {
        return apiCall('delete', `${PREFIX}/images/${imageID}`)
    },

    setProductThumbnail(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/thumbnail`, data)
    },

    getProductPrices(productID) {
        return apiCall('get', `${PREFIX}/${productID}/prices`)
    },

    addProductPrice(productID, data) {
        // window.axios.defaults.headers.common["Content-Type"] = 'multipart/form-data';
        return apiCall('post', `${PREFIX}/${productID}/prices`, data)
    },

    updateProductPrice(priceID, data) {
        return apiCall('post', `${PREFIX}/prices/${priceID}`, data)
    },

    deleteProductPrice(priceID) {
        return apiCall('delete', `${PREFIX}/prices/${priceID}`)
    },

    requestProductPriceFile(priceID) {
        return apiCall('get', `${PREFIX}/prices/${priceID}/request-file`)
    },

    getProductFeaturables(productID) {
        return apiCall('get', `${PREFIX}/${productID}/featurables`)
    },

    getProductFeatureIds(productID) {
        return apiCall('get', `${PREFIX}/${productID}/featureids`)
    },

    updateProductFeatures(productID, data){
        return apiCall('post', `${PREFIX}/${productID}/features`,data)
    },

    getProductSeo(productID) {
        return apiCall('get', `${PREFIX}/${productID}/seo`)
    },

    saveProductSeo(productID, data) {
        return apiCall('post', `${PREFIX}/${productID}/seo`, data)
    },


}